import { render, staticRenderFns } from "./UserProfileComp.vue?vue&type=template&id=b34a3572&scoped=true"
import script from "./UserProfileComp.vue?vue&type=script&lang=js"
export * from "./UserProfileComp.vue?vue&type=script&lang=js"
import style0 from "./UserProfileComp.vue?vue&type=style&index=0&id=b34a3572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34a3572",
  null
  
)

export default component.exports